import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleArrowRight,
  faArrowRight,
  faXmarkCircle,
} from "@fortawesome/free-solid-svg-icons";
import { Snackbar, Alert } from "@mui/material";

import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import imageTT from "../../assets/about/careerRequirment.png";
import Career from "../../assets/images/career.jpg";
import BASE_URL from "../../config/config";
import { Link } from "react-router-dom";
import Popup from "../common/Popup";
import { Helmet } from "react-helmet-async";

export default function JobBoard() {
  const fileInputRef = useRef(null);
  const [selectedJob, setSelectedJob] = useState([0]);
  const [showModal, setShowModal] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    position: "",
    experience: "",
    education: "",
    cv: null,
  });

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "cv") {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  // <<<<<<-----------------form posting section--------->>>>>>>
  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   const submitData = new FormData();
  //   submitData.append("fullName", formData.fullName);
  //   submitData.append("email", formData.email);
  //   submitData.append("phone", formData.phone);
  //   submitData.append("education", formData.education);
  //   submitData.append("experience", formData.experience);
  //   submitData.append("position", formData.position);
  //   submitData.append("cv", formData.cv);

  //   try {
  //     const response = await fetch(`${BASE_URL}/jobapply`, {
  //       method: "POST",
  //       body: submitData,
  //     });

  //     const result = await response.json();

  //     if (response.ok) {
  //       alert(" Application submitted successfully!");

  //       // ✅ Safely reset file input
  //       if (
  //         fileInputRef.current &&
  //         fileInputRef.current instanceof HTMLInputElement
  //       ) {
  //         fileInputRef.current.value = "";
  //       }

  //       // ✅ Reset form state
  //       setFormData({
  //         fullName: "",
  //         email: "",
  //         phone: "",
  //         position: "",
  //         experience: "",
  //         education: "",
  //         cv: null,
  //       });

  //       // ✅ Optionally close modal after submission
  //       setShowModal(false);
  //     } else {
  //       alert(" Submission failed: " + (result.message || "Unknown error"));
  //     }
  //   } catch (error) {
  //     console.error(" Error submitting form:", error);
  //     alert("Something went wrong while submitting the form.");
  //   }
  // };
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success", // 'error' | 'info' | 'warning'
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    const submitData = new FormData();
    submitData.append("fullName", formData.fullName);
    submitData.append("email", formData.email);
    submitData.append("phone", formData.phone);
    submitData.append("education", formData.education);
    submitData.append("experience", formData.experience);
    submitData.append("position", formData.position);
    submitData.append("cv", formData.cv);

    try {
      const response = await fetch(`${BASE_URL}/jobapply`, {
        method: "POST",
        body: submitData,
      });

      const result = await response.json();

      if (response.ok) {
        setSnackbar({
          open: true,
          message: "Application submitted successfully!",
          severity: "success",
        });

        if (
          fileInputRef.current &&
          fileInputRef.current instanceof HTMLInputElement
        ) {
          fileInputRef.current.value = "";
        }

        setFormData({
          fullName: "",
          email: "",
          phone: "",
          position: "",
          experience: "",
          education: "",
          cv: null,
        });

        setShowModal(false);
      } else {
        setSnackbar({
          open: true,
          message: result.message || "Submission failed.",
          severity: "error",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setSnackbar({
        open: true,
        message: "Something went wrong while submitting the form.",
        severity: "error",
      });
    }
  };

  const [careerJobs, setCareerJobs] = useState([]);

  const fetchJobs = async () => {
    try {
      const response = await fetch(`${BASE_URL}/careers/list`);
      const data = await response.json();
      // console.log("=====------------>>>>", data);
      if (data.data && data.data.length > 0) {
        setSelectedJob(data.data[0]);
      }
      if (response.ok) {
        setCareerJobs(data.data || []);
      } else {
        throw new Error(data.message || "Failed to fetch jobs");
      }
    } catch (error) {
      console.error("Error fetching jobs:", error.message);
    }
  };
  useEffect(() => {
    fetchJobs();
  }, []);

  const requirements = [
    "Written and verbal English language proficiency.",
    "Previous practical experience on any personal or commercial project involving the field for which you are applying.",
    "Proactivity in doing the task on your own, without waiting for someone to tell you to do it.",
    "Independence - trying to solve the task by yourself, before asking for help.",
    "Follows industry news and trends - reading industry blogs and news for fun.",
    "Meticulousness - finishing the task on your own, without relying on others to finish it.",
    "Responsibility - you keep your word.",
    "Written and verbal communication skills - ability to have a conversation with clients, partners, and companies Logit comes in contact with.",
    "Trustworthiness - we need to be able to rely on you.",
  ];
  return (
    <>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>Careers at Deetya Soft | Join Our IT & IVR Solutions Team</title>
        <meta
          name="description"
          content="Join Deetya Soft for careers in IT, IVR solutions, app development, and customer experience innovation."
        />
        <meta
          name="keywords"
          content="Deetya Soft Careers, Jobs at Deetya Soft, Career Opportunities in IT, IVR Solutions Jobs, IT Company Hiring India, Web Development Jobs, App Development Careers, Software Developer Jobs India, IT Support Careers, Current job openings at Deetya Soft"
        />
        <link rel="canonical" href="https://deetyasoft.com/career" />

        {/* Facebook Meta Tags */}
        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="article" />
        <meta property="og:url" content="https://deetyasoft.com/career" />
        <meta
          property="og:title"
          content="Careers at Deetya Soft | Join Our IT & IVR Solutions Team"
        />
        <meta
          property="og:description"
          content="Join Deetya Soft for careers in IT, IVR solutions, app development, and customer experience innovation."
        />
        <meta
          property="og:image"
          content="https://deetyasoft.com/static/media/career.729b66d1a9fa09f6b90c.jpg"
        />
        <meta property="og:site_name" content="deetyasoft.com" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/deetyasoftprivatelimited"
        />

        {/* Twitter Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://deetyasoft.com/career" />
        <meta
          name="twitter:title"
          content="Careers at Deetya Soft | Join Our IT & IVR Solutions Team"
        />
        <meta
          name="twitter:description"
          content="Join Deetya Soft for careers in IT, IVR solutions, app development, and customer experience innovation."
        />
        <meta
          name="twitter:image"
          content="https://deetyasoft.com/static/media/career.729b66d1a9fa09f6b90c.jpg"
        />
        <meta name="twitter:site" content="@DeetyaSoft" />
        <meta name="twitter:creator" content="@DeetyaSoft" />

        {/* Extra Meta Tags */}
        <meta name="yandex-verification" content="31c730ea93a5a9cd" />
        <meta name="copyright" content="Deetyasoft" />
        <meta name="author" content="Deetyasoft" />
        <meta name="email" content="info@deetyasoft.com" />
        <meta name="Distribution" content="Global" />
        <meta name="rating" content="general" />
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta property="bingbot" content="index, follow" />
        <meta name="Yahoobot" content="index, follow" />
        <meta name="MSNbot" content="index, follow" />
        <meta name="googlebot-news" content="index, follow" />
        <meta name="audience" content="all" />
        <meta name="geo.placename" content="Noida, Uttar Pradesh, India" />
        <meta name="geo.region" content="IN-UP" />
        <meta name="geo.position" content="28.644800;77.373300" />
        <meta name="ICBM" content="28.644800, 77.373300" />
        <link rel="alternate" href="https://deetyasoft.com" hreflang="en-us" />
        <meta httpEquiv="content-language" content="en-us" />
        <meta name="msvalidate.01" content="305155CCD42FD63B0A29555BBEE7CA03" />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {`{
          "@context": "http://schema.org",
          "@type": "Organization",
          "name": "Deetya Soft Pvt Ltd",
          "description": "Join Deetya Soft for careers in IT, IVR solutions, app development, and customer experience innovation.",
          "image": "https://deetyasoft.com/static/media/career.729b66d1a9fa09f6b90c.jpg",
          "logo": "https://www.deetyasoft.com/images/logo.png",
          "url": "https://www.deetyasoft.com",
          "telephone": ["+91-9015350505", "+91-9717055088"],
          "email": "info@deetyasoft.com",
          "sameAs": [
            "https://www.linkedin.com/company/deetya-soft-private-limited",
            "https://www.facebook.com/deetyasoftprivatelimited",
            "https://www.instagram.com/deetyasoft",
            "https://www.youtube.com/@deetyasoft",
            "https://www.crunchbase.com/organization/deetyasoft"
          ],
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "FF‑06, First Floor, Mahaluxmi Square, Plot No. C‑1, Abhay Khand II, Indirapuram",
            "addressLocality": "Ghaziabad",
            "addressRegion": "Uttar Pradesh",
            "postalCode": "201014",
            "addressCountry": "IN"
          }
        }`}
        </script>

        <script type="application/ld+json">
          {`{
          "@context": "http://schema.org",
          "@type": "Organization",
          "url": "https://www.deetyasoft.com",
          "contactPoint": [
            {
              "@type": "ContactPoint",
              "telephone": "+91-981-862-7588",
              "contactType": "technical support",
              "areaServed": "IN"
            },
            {
              "@type": "ContactPoint",
              "telephone": "+91-901-535-0505",
              "contactType": "sales",
              "areaServed": "IN"
            }
          ]
        }`}
        </script>

        <script type="application/ld+json">
          {`{
          "@context": "http://schema.org",
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Parshan "
          },
          "reviewBody": "Deetya Soft helps companies to enable effective business operations through custom web solutions, IVR, and cloud telephony services.",
          "url": "https://www.deetyasoft.com/",
          "description": "Deetya Soft Pvt Ltd offers services such as IVR systems, virtual phone numbers, toll-free numbers, call tracking, enquiry management, LMS, web solutions, VOIP, and cloud-based communication solutions.",
          "datePublished": "2025-06-17",
          "name": "Deetya Soft Pvt Ltd",
          "reviewRating": {
            "@type": "Rating",
            "worstRating": "1",
            "ratingValue": "5",
            "bestRating": "5"
          },
          "itemReviewed": {
            "@type": "Organization",
            "name": "Deetya Soft Pvt Ltd"
          }
        }`}
        </script>
      </Helmet>

      {showPopup && (
        <Popup
          message="Application submitted successfully!"
          onClose={() => setShowPopup(false)}
        />
      )}

      {/* hero sections */}
      <div className="w-full">
        {/* Full-width Image */}
        <div className="w-full">
          <img src={Career} alt="career" className="w-full h-full " />
        </div>

        {/* Breadcrumbs below image, aligned right */}
        <div className="w-full flex justify-start pl-2 my-4">
          <nav className="text-sm text-gray-600 flex items-center space-x-2">
            <Link to="/" className="hover:text-main1 font-semibold">
              Home
            </Link>
            <FontAwesomeIcon icon={faChevronRight} className="text-xs" />
            <Link to="/career" className="hover:text-main1 text-medium ">
              Career
            </Link>
          </nav>
        </div>
      </div>

      {/* minimum requiremt section */}
      <div className=" bg-gray-50">
        <div className="mx-auto md:px-10 px-3 py-8">
          <div className=" mx-auto px-4  text-center">
            <h3 className="md:text-3xl text-xl  mb-1 font-semibold">
              Minimum <span className="text-main1"> Requirements</span>
            </h3>
            {/* <div className=" md:w-40 w-20   h-1 bg-main1 mx-auto mb-5 rounded-full" /> */}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            {/* Image Section */}
            <div className="w-full max-w-md mx-auto order-2 md:order-1 px-4 sm:px-6 lg:px-8">
              <img
                src={imageTT}
                alt="Technical Maintenance"
                className="w-full h-full  object-cover"
              />
            </div>

            {/* Text Section */}
            <div className=" p-1 rounded-lg  order-1 md:order-2 ">
              <ul className="list-disc pl- space-y-2 text-gray-800">
                {requirements.map((item, index) => (
                  <li
                    key={index}
                    className="flex items-start gap-2 leading-relaxed"
                  >
                    <FontAwesomeIcon
                      icon={faCircleArrowRight}
                      className="text-main1 md:w-5 md:h-[18px] w-4 h-4 mt-1"
                    />
                    <span className=" text-sm md:text-[15px]">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* apply section here */}
      <div className=" ">
        <div className=" container mx-auto md:px-8 px-3 py-5">
          <h2 className="text-main text-lg  capitalize font-semibold mb-4">
            Showing {careerJobs?.length} positions
          </h2>
          <div className="flex flex-col  md:flex-row border rounded shadow-sm overflow-hidden">
            {/* Job List */}
            <div className="md:w-1/3 p-4 border-r">
              {careerJobs.map((job, i) => (
                <div
                  key={i}
                  onClick={() => setSelectedJob(job)}
                  className={`cursor-pointer p-2 md:p-4 border-b  hover:bg-gray-100 ${
                    selectedJob.code === job.code
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <h3 className="font-semibold text-sm md:text-lg">
                        {job.title}
                      </h3>
                      {job.urgent && (
                        <span className="bg-orangeheading text-white text-[10px] px-1 py-[1px] rounded">
                          urgent
                        </span>
                      )}
                    </div>
                    <div>
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        className=" w-5 h-5 mt-1"
                      />
                    </div>
                  </div>

                  <p className="text-main font-semibold text-sm">
                    Ex- {job.experience}{" "}
                  </p>
                </div>
              ))}
            </div>

            {/* Job Detail */}
            <div className="md:w-2/3 w-full md:p-8 p-3 relative">
              <div className="flex justify-between items-start mb-2">
                <div>
                  <h3 className="md:text-2xl  text-lg font-semibold text-gray-800">
                    {selectedJob.title}
                  </h3>
                  <p className="text-main font-semibold text-sm">
                    {selectedJob.experience}
                  </p>
                </div>
                <button
                  onClick={() => {
                    setShowModal(true);
                    setFormData({ ...formData, position: selectedJob.title });
                  }}
                  className="bg-orangeheading text-white md:px-4 md:py-2 px-2 py-1 rounded-full hover:bg-orange-600 transition text-sm"
                >
                  Apply Now
                </button>
              </div>

              <h4 className="md:text-lg text-base font-semibold mt-2 mb-1">
                Job Description
              </h4>
              {/* <p className="font-semibold mb-1">Contact Us - 9717038635</p> */}
              <p
                className="md:text-base text-sm text-gray-700 whitespace-pre-line"
                dangerouslySetInnerHTML={{ __html: selectedJob.description }}
              ></p>
            </div>
          </div>
          {/* Modal */}
          {showModal && (
            <div className="fixed  inset-0 z-[999] bg-black bg-opacity-50 flex items-center justify-center h-screen">
              <div
                className="bg-white rounded-xl p-4 md:p-8 w-full max-w-4xl shadow-xl relative
                 md:max-h-full md:overflow-visible 
                 max-h-[100vh] overflow-y-auto"
              >
                <button
                  onClick={() => setShowModal(false)}
                  className="absolute md:top-4 top-3 right-4 text-gray-500 hover:text-gray-800 text-2xl"
                >
                  <FontAwesomeIcon icon={faXmarkCircle} className="w-5 h-5" />
                </button>

                <h2 className="md:text-2xl text-base font-semibold text-orangeheading text-center mb-4">
                  Apply for {selectedJob.title}
                </h2>

                <form
                  onSubmit={handleSubmit}
                  className="grid grid-cols-1 md:grid-cols-2 gap-4"
                >
                  <input
                    type="text"
                    name="fullName"
                    placeholder="Full Name"
                    className="w-full border text-sm border-gray-200 rounded-lg px-4 py-3 text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-main1"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    required
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    className="w-full border text-sm border-gray-200 rounded-lg px-4 py-3 text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-main1"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                  <input
                    type="text"
                    name="phone"
                    placeholder="Mobile Number"
                    className="w-full border text-sm border-gray-200 rounded-lg px-4 py-3 text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-main1"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                  <input
                    type="text"
                    name="education"
                    placeholder="Education (Degree, University)"
                    className="w-full border text-sm border-gray-200 rounded-lg px-4 py-3 text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-main1"
                    value={formData.education}
                    onChange={handleInputChange}
                    required
                  />
                  <select
                    name="position"
                    className="w-full border text-sm border-gray-200 rounded-lg px-4 py-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-main1"
                    value={formData.position}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Position Applying For</option>
                    {careerJobs.map((job) => (
                      <option key={job.code} value={job.title}>
                        {job.title}
                      </option>
                    ))}
                  </select>
                  <select
                    name="experience"
                    className="w-full border text-sm border-gray-200 rounded-lg px-4 py-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-main1"
                    value={formData.experience}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select Experience</option>
                    {careerJobs.map((job) => (
                      <option key={job.code} value={job.experience}>
                        {job.experience}
                      </option>
                    ))}
                  </select>
                  <div className="md:col-span-2">
                    <label className="block text-gray-700 font-medium mb-1">
                      Upload CV (PDF, DOCX)
                    </label>

                    <input
                      type="file"
                      name="cv"
                      accept=".pdf,.doc,.docx"
                      ref={fileInputRef} // ✅ attach the ref here
                      onChange={handleInputChange}
                      required
                      className="w-full border text-sm border-gray-200 rounded-lg px-4 py-3 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:bg-gray-100 file:text-gray-700 hover:file:bg-gray-200 focus:outline-none"
                    />
                  </div>
                  <div className="md:col-span-2">
                    <button
                      type="submit"
                      className="w-full bg-orangeheading hover:bg-orange-600 text-white font-semibold py-3 rounded-lg transition duration-300"
                    >
                      Submit Application
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
        <Snackbar
          open={snackbar.open}
          autoHideDuration={4000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={() => setSnackbar({ ...snackbar, open: false })}
            severity={snackbar.severity}
            sx={{ width: "100%" }}
            variant="filled"
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </div>
    </>
  );
}
